<template>
    <div class="inspector-section is-padded">
        <BLoading active v-if="loading" :isFullPage="false"/>
        <div class="inspection-section-header" @click="handleToggle" :class="{ pointer: collapsable }">
            <Title>{{ title }}</Title>
            <div class="inspector-section-header-toggle" v-if="collapsable">
                <BIcon :icon="show ? 'minus' : 'plus'" v-if="!loading"/>
            </div>
        </div>
        <div v-if="show" class="inspector-section-content">
            <slot/>
        </div>
    </div>
</template>

<script>

import slugify from 'slugify';
import Storage from '../Storage';

export default {
  name: 'InspectorSection',
  computed: {
    storageKey() {
      return slugify(`${this.$route.name}-${this.title}`).toLowerCase();
    },
  },
  created() {

    if (this.storageKey && this.storage && this.storage[this.storageKey] !== undefined) {
      this.show = this.storage[this.storageKey];
    } else {
      this.show = this.open;
    }

  },
  data() {
    return {
      show: false,
      storage: Storage.getItem('InspectorSectionState') || {}
    };
  },
  methods: {
    close() {
      this.show = false;
    },
    handleToggle() {
      if (this.collapsable) {

        this.$emit(this.show ? 'closed' : 'opened');
        let show = !this.show;

        this.show = show;

        this.storage = {
          ...Storage.getItem('InspectorSectionState') || {},
          [this.storageKey]: show,
        }

        Storage.setItem('InspectorSectionState', this.storage);
      }
    },
  },
  props: {
    collapsable: {
      default: true,
      type: Boolean,
    },
    loading: {
      default: false,
      type: Boolean,
    },
    open: {
      default: false,
      type: Boolean,
    },
    title: {
      required: true,
      type: String,
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.$emit('open');
      } else {
        this.$emit('close');
      }
    },
  },
};
</script>

<style lang="scss">
.inspector-section {

    border-bottom: 1px solid $black-ter;
    position: relative;

    .loading-icon {
        font-size: 0.5em;
    }

    .inspection-section-header {
        align-items: center;
        display: flex;
        justify-content: space-between;
        margin: -15px;
        padding: 15px;

        .title {
            font-size: 1em;
            margin: 0;
            padding: 0;
            text-transform: uppercase;
        }
    }

    .inspector-section-content {
        padding: 15px 0 5px;
    }
}
</style>
